import React from 'react';
import './Loader.css';

/**
 * Reusable Loader Component - Uses Bootstrap spinner
 * @param {string} message - Optional loading message to display
 * @param {boolean} fullScreen - Whether to show as full-screen overlay (default: false)
 */
const Loader = ({
    message = 'Loading...',
    fullScreen = false
}) => {
    if (fullScreen) {
        return (
            <div className="loader-overlay">
                <div className="text-center">
                    <div className="spinner-border text-primary mb-2" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <h6 className="text-muted mb-0">{message}</h6>
                </div>
            </div>
        );
    }

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
            <div className="text-center">
                <div className="spinner-border text-primary mb-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <h6 className="text-muted mb-0">{message}</h6>
            </div>
        </div>
    );
};

export default Loader;
